import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";
import { useUi, cx } from "../../ui";
import Plate from "../../components/Plate";
import { formatDayLong, formatMovementTime } from "../forecastRange";

const useStyles = makeStyles({
  panel: { marginTop: 12, borderRadius: 6, border: `1px solid rgba(49,39,184,0.3)`, background: T.primaryTint, padding: 12 },
  header: { marginBottom: 8, display: "flex", alignItems: "center", justifyContent: "space-between" },
  title: { fontSize: 14, fontWeight: 600, color: T.fg },
  count: { marginLeft: 8, fontSize: 12, fontWeight: 400, color: T.mutedFg },
  closeBtn: { fontSize: 11, padding: "2px 8px" },
  list: { margin: 0, padding: 0, listStyle: "none", overflow: "hidden", borderRadius: 6, border: `1px solid ${T.border}`, background: T.elevated, fontSize: 14, maxHeight: 320, overflowY: "auto" },
  item: { display: "flex", alignItems: "center", gap: 12, padding: "8px 12px" },
  kindBadge: { borderRadius: 4, padding: "2px 6px", fontSize: 10, fontWeight: 600, textTransform: "uppercase" },
  time: { width: 48, fontSize: 12, color: T.mutedFg, fontVariantNumeric: "tabular-nums" },
  timeScheduled: { color: T.subtleFg, fontStyle: "italic" },
  name: { minWidth: 0, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 500, color: T.fg },
  unknown: { color: T.mutedFg, fontStyle: "italic" },
  vipBadge: { borderRadius: 4, border: `1px solid rgba(62,172,77,0.4)`, background: T.successTint, color: T.successText, padding: "2px 6px", fontSize: 10, fontWeight: 600 },
});

export default function ForecastMovementsCard({ date, movements, timezone, onClose }) {
  const s = useStyles();
  const ui = useUi();

  return (
    <div className={s.panel}>
      <div className={s.header}>
        <div className={s.title}>
          {formatDayLong(date)}
          <span className={s.count}>
            {movements.length} {movements.length === 1 ? "movement" : "movements"}
          </span>
        </div>
        <button onClick={onClose} className={cx(ui.mutedBtn, s.closeBtn)}>
          Close
        </button>
      </div>
      <ul className={s.list}>
        {movements.map((m, idx) => (
          <li
            key={`${m.bookingId}-${m.kind}`}
            className={s.item}
            style={{ borderTop: idx === 0 ? "none" : `1px solid ${T.borderSoft}` }}
          >
            <span
              className={s.kindBadge}
              style={{
                background: m.kind === "ARRIVAL" ? T.successTint : T.primaryTint,
                color: m.kind === "ARRIVAL" ? T.successText : T.primary,
              }}
            >
              {m.kind === "ARRIVAL" ? "In" : "Out"}
            </span>
            <span
              className={cx(s.time, !m.isExpected && s.timeScheduled)}
              title={
                m.isExpected
                  ? "Time the guest gave us"
                  : "Booked time - the guest has not told us when they are coming"
              }
            >
              {formatMovementTime(m.at, timezone)}
            </span>
            <Plate size={10}>{m.plate || "—"}</Plate>
            <span className={s.name}>
              {m.guestName || <span className={s.unknown}>Unknown</span>}
            </span>
            {m.isVip && <span className={s.vipBadge}>VIP</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
